	<template>
  <div class="container" v-if="pdfSrc">
    <div>
      <pdf
        :src="pdfSrc"
        :page="currentPage"
        @num-pages="pageCount = $event"
        @page-loaded="currentPage = $event"
        @loaded="loadPdfHandler"
      >
      </pdf>
    </div>
    <!--页码-->
    <div class="pdf" v-show="fileType === 'pdf'">
      <div class="pagesize">
        <!--上一页-->
        <div
          @click="changePdfPage(0)"
          class="lturn"
          :class="{ grey: currentPage == 1 }"
        >
          上一页
        </div>
        <span class="texts"> {{ currentPage }} </span>
        <span>&nbsp;/&nbsp;</span>
        <span>{{ pageCount }}</span>
        <!--下一页-->
        <div
          @click="changePdfPage(1)"
          class="rturn"
          :class="{ grey: currentPage == pageCount }"
        >
          下一页
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import pdf from 'vue-pdf'
export default {
  components: { pdf },
  data() {
    return {
      currentPage: 0,
      pageCount: 0,
      fileType: 'pdf',
      pdfSrc: null,
      fromPath: null
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fromPath = from.path
    })
  },
  methods: {
    // 返回上级
    goBack() {
      this.$router.back()
      // this.$router.replace(this.fromPath)
    },

    // 修改页面
    changePdfPage(val) {
      if (val === 0 && this.currentPage > 1) {
        this.currentPage--
      }
      if (val === 1 && this.currentPage < this.pageCount) {
        this.currentPage++
      }
    },

    // pdf加载时
    loadPdfHandler() {
      this.currentPage = 1
    }
  },
  created() {
    this.pdfSrc = this.$route.query.url
  }
}
</script>
	<style lang="less" scoped>
.pdf {
  text-align: center;
}
.pdf {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  margin: 0 auto;
  overflow-x: hidden;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  .pagesize {
    width: 100%;
    font-size: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    .lturn {
      margin-right: 15px;
    }
    .texts {
      color: #ab3b91;
    }
    .rturn {
      margin-left: 15px;
    }
  }
}
</style>